<template>
  <span v-if="visible" :class="rootClass" title="官方认证测评，可用于朋友资料可见性筛选">官方认证</span>
</template>

<script>
import { computed } from 'vue'
import { isOfficialCertified } from '@/utils/examPricing'

export default {
  name: 'ExamOfficialBadge',
  props: {
    exam: { type: Object, default: null },
    certified: { type: [Number, Boolean], default: undefined },
    /** inline：行内胶囊；title：标题旁；thumb：缩略图角标 */
    variant: {
      type: String,
      default: 'inline',
      validator: (v) => ['inline', 'title', 'thumb'].includes(v)
    }
  },
  setup(props) {
    const visible = computed(() => {
      if (props.certified !== undefined && props.certified !== null) {
        return props.certified === true || Number(props.certified) === 1
      }
      return isOfficialCertified(props.exam)
    })
    const rootClass = computed(() => [
      'exam-official-badge',
      `exam-official-badge--${props.variant}`
    ])
    return { visible, rootClass }
  }
}
</script>

<style scoped>
.exam-official-badge {
  display: inline-flex;
  align-items: center;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.5px;
  background: linear-gradient(135deg, #409eff 0%, #337ecc 100%);
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.35);
}

.exam-official-badge--inline {
  padding: 2px 8px;
  font-size: 12px;
  border-radius: 999px;
}

.exam-official-badge--title {
  margin-left: 0;
  padding: 4px 10px;
  font-size: 13px;
  border-radius: 8px;
  vertical-align: middle;
}

.exam-official-badge--thumb {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 4px 10px;
  font-size: 12px;
  border-radius: 0 0 0 8px;
}
</style>
